<template>
  <div class="product-price-filter-page col-block default-shadow" :style="{ height: minHeight }">
    <div v-if="disabled" class="mask"></div>
    <div class="title-container center-block">
      <div class="title">{{ title }}</div>
    </div>
    <div class="filter-container">
      <customFilter
        :init="init"
        :filters="filters.options"
        @change="conditions => filtersOnChange(conditions)"
        @pressEnter="() => updateFilter()"
      ></customFilter>
      <div class="button">
        <button type="button" name="button" class="main-button" @click="e => updateFilter()">
          <span>搜尋</span>
        </button>
      </div>
    </div>
    <template v-if="rolePermission(['advance', 'admin'])">
      <hr>
      <div class="other-container col-block" :style="{ flex: 1 }">
        <div class="other-title">零售價格資料上傳</div>
        <div :style="{ height: '15px' }"></div>
        <div class="button">
          <button type="button" name="button" class="main-button" @click="e => createProductPrice()">
            <span>新增</span>
          </button>
        </div>
        <div :style="{ height: '20px' }"></div>
        <div class="other-info">您可點選右側分頁查看上傳紀錄。</div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </template>
    <div v-else :style="{ flex: 1 }"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import customFilter from '../tool/customFilter'
import userPermission from '../../mixins/userPermission'

export default {
  components: {
    customFilter
  },
  mixins: [
    userPermission
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      init: {},
      conditions: {
        filters: {}
      }
    }
  },
  created () {
    this.init = this.filters.init || {}
  },
  watch: {
    'filters.init' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.init = this.filters.init || this.init
      }
    },
    'conditions.filters' (nv, ov) {
      if (nv.kind !== ov.kind) {
        this.init = {
          ...this.init,
          ...this.conditions.filters,
          crop_name: ''
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    filtersOnChange (conditions) {
      const init = false
      this.conditions.filters = conditions
      if (init) {
        this.updateFilter()
      }
    },
    updateFilter () {
      this.$emit('changeFilters', JSON.parse(JSON.stringify(this.conditions.filters)))
    },
    createProductPrice () {
      this.setModalAction({
        action: 'editProductPrice',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: '新增零售價格資料',
          editable: true
        },
        callback: async result => {
          if (result) {
            this.$emit('updateList')
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productPrice/filter.vue